import { EventDetails, EventDetailsFrontend, Location } from "../../../backendApi/generated"
import { features } from "../../../features"
import { LinkProps } from "../../Link"
import { moment } from "../../../utils/moment"

export const extractSinglesFromOne = (event: EventDetails): EventDetails[] => {
  const self = event.Kind == 'single' ? [event] : []
  const children = event.ChildEvents?.map(extractSinglesFromOne) || []
  return self.concat(...children)
}

export const extractSingles = (events: EventDetails[]): EventDetails[] => [].concat(...events.map(extractSinglesFromOne))

export const getDateElements = (event: EventDetailsFrontend) => {
  const date = moment(event.Start).calendar()
  const start = new Date(event.Start).toLocaleTimeString('nl')
  const end = new Date(event.End).toLocaleTimeString('nl')
  return { date, start, end }
}

export const linkFor = (event: EventDetails): LinkProps => {
  const config = features().events
  if (config == 'off') return null
  return { url: `${config.prefix}/${event.Id}` }
}

/**
 * Returns a string to represent the Location. If the location has a Region _and_ the Region does not
 * appear in the Location's Name, the Region is added in parenthesis.
 * 
 * So `{ Name: "Bibliotheek De Mare", Region: "Alkmaar" }` becomes "Bibliotheek De Mare (Alkmaar)",  
 * and `{ Name: "Bibliotheek Oldenzaal", Region: "Oldenzaal" }` becomes "Bibliotheek Oldenzaal"
 * 
 * @param loc An event Location
 * @returns The name of the Location with optionally the name of its Region
 */
export const locationString = (loc: Location) => `${loc.Name}${loc.Region && !loc.Name.toLocaleLowerCase().includes(loc.Region.toLocaleLowerCase()) ? ` (${loc.Region})` : ''}`
